function MonitorCtrl($scope, $rootScope, $state, $timeout) {
    var DEFAULT_TAB = $state.current.defaultCurtab;
    $scope.showRT = true; // used to hide date picker

    function init() {
        setTaggedTabs();
        setFilter();
        setCurrentTab();
        setHostsTitle();
    }

    // used if some tabs are protected by tags
    function setTaggedTabs() {
        if ($scope.$root && $scope.$root.tags) {
            setDynamicTabs();
        } else {
            $timeout(function() {
                setTaggedTabs();
            }, 10, false);
        }
    }

    function setCurrentTab() {
        var paramTab = $state.params.curtab;
        var tabId = paramTab || DEFAULT_TAB;
        $scope.currentTab = $scope.tabs.filter(function(item) { return item.id === tabId; })[0];

        if (!$scope.currentTab) {
             $scope.currentTab = $scope.tabs.filter(function(item) { return item.id === DEFAULT_TAB; })[0];
        }

        setRootCategory();
    }

    function setRootCategory () {
        if (!$scope.$root) {
            $timeout(function() {
                setRootCategory();
            }, 20, false);
            return;
        }

        $timeout(function() {
            $rootScope.currentCategory = $scope.currentTab.id;
        }, 0);
    }

    //changes the tab title according to User Awareness configuration
    function setHostsTitle() {
        if($scope.$root.userAwareness === undefined) {
            $timeout(function() {
                setHostsTitle();
            }, 20);
        }
        else {
            $scope.tabs.forEach(function(item) {
                if(item.id === 'hosts') {
                   item.name =  getHostsTitleByUAConfiguration();
               }
             })
        }
    }

    $scope.tabs = [
        { id: 'networking', name: 'Connectivity' },
        { id: 'qos', name: 'Priority Analyzer'  },
        { id: 'usage', name: 'Usage' },
        { id: 'hosts', name:  getHostsTitleByUAConfiguration() },
        { id: 'events-discovery', name: 'Event Discovery' },
        { id: 'realtime', name: 'Real-Time' },
    ];


    function setDynamicTabs() {
        let offset = 0;
        // adds last mile monitoring and offcloud tabs if site is relevant
        store.fetch({
            method : 'GET',
            url : 'isSocketSite',
            queryParams: { accountDbId: $state.params.accountId,
                          siteProtoId: $scope.pid
                       },
            success: function(data) {
                 if(data.isSocketSite){
                    $scope.tabs.splice(5 + offset, 0, { id: 'lastMile', name: 'Last-Mile' });

                    if (data.isOffcloudSite) {
                        $scope.tabs.splice(6 + offset, 0, { id: 'offcloud', name: 'Off-Cloud' });
                    }
                 }
                 setCurrentTab();
            }
        });
    }

    $scope.$root.dividedInner = true;
    $scope.entity = {};

    $scope.entityFilterOptions = {
        hideTraffic: true,
        hideCurrents: true,
        hideInfo: true,
        showTicks: true
    };

    $scope.deviceId = $state.params.deviceId;
    $scope.admin = $state.current.admin;
    $scope.type = $state.params.type || $state.current.type;
    $scope.single = $state.params.single;

    $scope.changePid = function(){
        $scope.removeURLFilters();
    };

     //returns tab title Hosts / Users&Hosts according to User Awareness configuration
        function getHostsTitleByUAConfiguration (){
             var title = $scope.$root.userAwareness ? 'Users & Hosts' : 'Hosts';
             return title;
        }

    $scope.toggleFilter = function(elId){
        var targetType;
        if($scope.type === "sites" || $scope.type === "logins"){
            if($scope.type === "logins"){
                targetType = "users";
            }
            else {
                targetType = $scope.type;
            }
        }

        $scope.toggleFilterDlg(elId, targetType);
    };


    var monitoringFilter = $scope.tabFilter;
    if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
        $scope.singlePid = true;
        $scope.pid = monitoringFilter.pid;
        $scope.pidtype = monitoringFilter.type + 's';

        $scope.$watch('entityFilterOptions', function(newVal, oldVal){
            if($scope.entityFilterOptions && $scope.entityFilterOptions.updated){
                $scope.entityFilterOptions.updated = false;
            }
        }, true);

        setCurrentTab();
    }

    $scope.backPID = function(){
        switch ($scope.type) {
            case "sites":
                $state.go('app.monitorSites');
                break;
            case "logins":
                $state.go('app.monitorLogins');
                break;
        }
    };

    $scope.removePID = ($scope.type === "sites" || $scope.type === "logins" || !($scope.pid || $scope.pid === 0))? null : function(){
        var monitoringFilter = $scope.tabFilter;
        if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
            $scope.removeFilter();
        }
    };


    $scope.facets = [{"id": "type", order:1},{"id": "site_id", "ignoreFilter": true, label: "Client", "hide": true},{"id": "rt_site_id", "label": "Destination"},{"id": "appid", "label": "Destination"},
        {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},{"id": "url_category", "label": "Destination"}];

    function setFilter(){
        switch ($scope.type) {
            case "sites":
                $scope.filters = {
                    "Client": {
                        "label": "site_id",
                        "values": [$scope.pid]
                    }
                };
                break;
            case "logins":
                $scope.filters = {
                    "Client": {
                        "label": "site_id",
                        "values": [$scope.pid]
                    }
                };
                break;
        }
    }

    $scope.changeTab = function(newTab) {
        if(newTab.id !== $scope.currentTab.id) {
            $scope.currentTab = newTab;

            if($scope.currentTab){
                $scope.$root.currentCategory = $scope.currentTab.id;
            }
            else {
              $scope.$root.currentCategory  = DEFAULT_TAB.id;
            }
            $state.go($state.current.name, {
                curtab: newTab.id
            });
        }
    };

    init();
}
